class GoogleMaps {
    constructor() {
        this._init()
    }
    _init() {

        // Create the script tag, set the appropriate attributes
        var script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDWejuSShPutXsL23d0ahKJZkFTU_QQnSg&callback=initMap';
        script.defer = true;
        script.async = true;

        // Attach your callback function to the `window` object
        window.initMap = function() {
        // JS API is loaded and available
            var companyLatLng = {lat: 41.521686, lng: -8.340879};
           
            var map = new google.maps.Map(document.getElementById("map"), {
                center: companyLatLng,
                zoom: 15
            });

            var marker = new google.maps.Marker({
                position: companyLatLng,
                title: 'Carpiave HELLLLO',
                visible: true
            });


            marker.setMap(map);
        };
        // Append the 'script' element to 'head'
        document.head.appendChild(script);
    }
}
export default GoogleMaps